"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapAlgoliaPageToPage = void 0;
const mapAlgoliaPageToPage = (page) => {
    return {
        pageId: page.objectID,
        title: page.title,
        inPreview: page.inPreview,
        url: page.url,
        numberOfProducts: page.numberOfProducts,
        // eslint-disable-next-line no-underscore-dangle
        highlightedTitle: page._highlightResult?.title?.value,
    };
};
exports.mapAlgoliaPageToPage = mapAlgoliaPageToPage;
//# sourceMappingURL=mapAlgoliaPageToPage.js.map